import { Dealer } from '@api/types';
import { fullDateAndTime } from '@utils/date.utils';
import { getPublicAddress } from '../FindDealer/FindDealer.config';
export const getDealerItems = (dealer: Dealer) => [
  { fieldName: 'name', fieldValue: getPublicAddress(dealer)?.name },
  { fieldName: 'customerNo', fieldValue: dealer.customerNo },
  { fieldName: 'quantityOfUsers', fieldValue: dealer?.quantityOfUsers?.toString() },
  { fieldName: 'lastOrderDate', fieldValue: fullDateAndTime(dealer.lastOrderDate) },
  { fieldName: 'lastLoginDate', fieldValue: fullDateAndTime(dealer.lastLoginDate) },
];
